module.exports = __webpack_public_path__ + "img/eye.e693b32d.svg";